import fontsData from '../data/fonts.json';
import {ConfigDispatch} from "../context/ConfigContext";
import {useContext} from "react";
import {ModalDispatch} from "../context/ModalContext";
import {useLanguage} from "../context/LanguageContext";

function FontSelector({modal}) {
    const {t} = useLanguage();
    const dispatch = useContext(ConfigDispatch);
    const modalDispatch = useContext(ModalDispatch);
    const handleClick = (e) => {
        dispatch({
            type: 'changeFontFamily',
            payload: e.target.style.fontFamily
        });
        modalDispatch({
            type: 'hideModal'
        });
    }

    const translateFont = (name) => {
        const key = `configData.fonts.${name}`;
        const translated = t(key);
        return translated === key ? name : translated;
    };

    const fontsList = fontsData.fonts.map(font => {
        return (
            <button
                className="fonts-selector__font"
                key={font.name}
                style={{fontFamily: "Monserrat, sans-serif"}}
                onClick={handleClick}
                aria-label={t('fontSelector.selectFont', {name: translateFont(font.name)})}
                type="button"
            >
                {translateFont(font.name)}
            </button>
        )
    });

    return (
        <div className="fonts-selector" role="list" aria-label={t('fontSelector.fontList')}>
            {fontsList}
        </div>
    )
}

export default FontSelector;
